import { HomeFeedResponse } from "@/clients/models/HomeFeedResponse";
import { MealsService } from "@/clients/services/MealsService";
import { QueryKeys } from "@/constants/query-keys";
import { QueryStaleTime } from "@/constants/query-stale-time";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

const EMPTY_HOME_FEED_RESPONSE: HomeFeedResponse = {
  meals: [],
  total_results: 0,
};

export const useGetPopularMeals = () => {
  const { data, isLoading, isFetching, isError, error, refetch } = useQuery<HomeFeedResponse>({
    queryKey: [QueryKeys.POPULAR_MEALS],
    staleTime: QueryStaleTime.MEDIUM,
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const { data } = await MealsService.getPopularMealsApiV1MealsPopularGet(user.id);
      return data ?? EMPTY_HOME_FEED_RESPONSE;
    },
  });

  return {
    popularMeals: data?.meals ?? [],
    totalResults: data?.total_results ?? 0,
    isLoading,
    isFetching,
    isError,
    error,
    refetch,
  };
};
